import { render, staticRenderFns } from "./PrivacyPolicyCreate.vue?vue&type=template&id=74965f0c&"
import script from "./PrivacyPolicyCreate.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports